/* 0511ER – eigene Tracking-Ereignisse (Sprint 11).
   Werden über Shopify Customer Events veröffentlicht (Shopify.analytics.publish).
   Pixel (Meta, Google) bekommen sie nur, wenn sie dafür eingerichtet sind und der Besucher zugestimmt hat –
   die Einwilligung verwaltet Shopify. Kein eigenes Tracking, keine Cookies.
   Ereignisse: bundle_selected, bundle_upgrade, upsell_add, district_view, drop_signup, restock_signup. */
(function () {
  function senden(name, daten) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, daten || {});
      }
    } catch (e) {}
  }

  // Produktseite: Set gewählt
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches && el.matches('[data-kaufart]') && el.value === 'set' && el.checked) {
      var titel = document.querySelector('.pdp-titel');
      senden('bundle_selected', { produkt: titel ? titel.textContent.trim() : '' });
    }
  });

  // Warenkorb: Set-Upgrade und Empfehlung
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-set-upgrade]')) senden('bundle_upgrade', {});
    if (e.target.closest('[data-upsell-add]')) senden('upsell_add', {});
  });

  // Drop List und Restock
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.id) return;
    if (f.id === 'drop-liste-form') senden('drop_signup', { seite: location.pathname });
    if (f.id === 'restock-form') senden('restock_signup', { seite: location.pathname });
    if (f.id === 'plz-wunsch-form') {
      var plz = f.querySelector('[data-plz-eingabe]');
      senden('drop_signup', { seite: location.pathname, plz_wunsch: plz ? plz.value : '' });
    }
  });

  // Stadtteil-Seite aufgerufen
  if (document.body && document.body.classList.contains('template-stadtteil')) {
    var plz = document.querySelector('.st-plz');
    var name = document.querySelector('.st-name');
    senden('district_view', { plz: plz ? plz.textContent.trim() : '', stadtteil: name ? name.textContent.trim() : '' });
  }
})();
